import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./user_right.js";
//#region src/user_right_helper.ts
var user_right_helper_exports = /* @__PURE__ */ __exportAll({
	apiTokenRightName: () => apiTokenRightName,
	findMissingPrerequisites: () => findMissingPrerequisites,
	getAllPrerequisites: () => getAllPrerequisites,
	getDirectPrerequisites: () => getDirectPrerequisites,
	isAdminRight: () => isAdminRight,
	isApiRight: () => isApiRight,
	isApiTokenRight: () => isApiTokenRight,
	isBiteRight: () => isBiteRight,
	isResellerRight: () => isResellerRight,
	rightsMeetPrerequisiteRequirements: () => rightsMeetPrerequisiteRequirements
});
function isBiteRight(right) {
	switch (right) {
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 130: return true;
		case 89:
		case 27:
		case 12:
		case 302:
		case 301:
		case 300:
		case 21:
		case 91:
		case 82:
		case 50:
		case 11:
		case 38:
		case 10:
		case 90:
		case 57:
		case 83:
		case 67:
		case 51:
		case 96:
		case 65:
		case 47:
		case 92:
		case 72:
		case 95:
		case 45:
		case 40:
		case 97:
		case 46:
		case 41:
		case 60:
		case 68:
		case 94:
		case 84:
		case 66:
		case 20:
		case 30:
		case 2:
		case 56:
		case 52:
		case 34:
		case 71:
		case 28:
		case 25:
		case 93:
		case 73: return false;
	}
}
function isAdminRight(right) {
	switch (right) {
		case 89:
		case 27:
		case 21:
		case 82:
		case 50:
		case 38:
		case 57:
		case 83:
		case 67:
		case 51:
		case 65:
		case 47:
		case 72:
		case 45:
		case 40:
		case 46:
		case 41:
		case 60:
		case 68:
		case 84:
		case 66:
		case 20:
		case 30:
		case 56:
		case 52:
		case 34:
		case 71:
		case 28:
		case 25:
		case 73: return true;
		case 12:
		case 302:
		case 301:
		case 300:
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 91:
		case 11:
		case 10:
		case 90:
		case 96:
		case 92:
		case 95:
		case 130:
		case 97:
		case 94:
		case 2:
		case 93: return false;
	}
}
function isResellerRight(right) {
	switch (right) {
		case 91:
		case 90:
		case 96:
		case 92:
		case 95:
		case 97:
		case 94:
		case 93: return true;
		case 89:
		case 27:
		case 12:
		case 302:
		case 301:
		case 300:
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 21:
		case 82:
		case 50:
		case 11:
		case 38:
		case 10:
		case 57:
		case 83:
		case 67:
		case 51:
		case 65:
		case 47:
		case 72:
		case 130:
		case 45:
		case 40:
		case 46:
		case 41:
		case 60:
		case 68:
		case 84:
		case 66:
		case 20:
		case 30:
		case 2:
		case 56:
		case 52:
		case 34:
		case 71:
		case 28:
		case 25:
		case 73: return false;
	}
}
function isApiRight(right) {
	switch (right) {
		case 12:
		case 302:
		case 301:
		case 300:
		case 11:
		case 10:
		case 2: return true;
		case 89:
		case 27:
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 21:
		case 91:
		case 82:
		case 50:
		case 38:
		case 90:
		case 57:
		case 83:
		case 67:
		case 51:
		case 96:
		case 65:
		case 47:
		case 92:
		case 72:
		case 95:
		case 130:
		case 45:
		case 40:
		case 97:
		case 46:
		case 41:
		case 60:
		case 68:
		case 94:
		case 84:
		case 66:
		case 20:
		case 30:
		case 56:
		case 52:
		case 34:
		case 71:
		case 28:
		case 25:
		case 93:
		case 73: return false;
	}
}
function isApiTokenRight(right) {
	switch (right) {
		case 302:
		case 301:
		case 300: return true;
		case 89:
		case 27:
		case 12:
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 21:
		case 91:
		case 82:
		case 50:
		case 11:
		case 38:
		case 10:
		case 90:
		case 57:
		case 83:
		case 67:
		case 51:
		case 96:
		case 65:
		case 47:
		case 92:
		case 72:
		case 95:
		case 130:
		case 45:
		case 40:
		case 97:
		case 46:
		case 41:
		case 60:
		case 68:
		case 94:
		case 84:
		case 66:
		case 20:
		case 30:
		case 2:
		case 56:
		case 52:
		case 34:
		case 71:
		case 28:
		case 25:
		case 93:
		case 73: return false;
	}
}
/** Human-readable name for an API-token sub-right. */
function apiTokenRightName(right) {
	switch (right) {
		case 302: return "Get Locations";
		case 301: return "Mobile App";
		case 300: return "Reporting";
	}
	throw new Error(`not an api-token sub-right: ${right}`);
}
/**
* @returns The next layer in the tree of rights that the user is required to have to use the
*     given right. These rights may also have prerequisites that the given right require as well.
*/
function getDirectPrerequisites(right) {
	switch (right) {
		case 20:
		case 30: return [25];
		case 38: return [28];
		case 72:
		case 46: return [28, 27];
		case 40: return [38, 41];
		case 82: return [65];
		case 91:
		case 90:
		case 96:
		case 92:
		case 95:
		case 97:
		case 94:
		case 93: return [89];
		case 302:
		case 301:
		case 300: return [12];
		case 21:
		case 50:
		case 57:
		case 83:
		case 67:
		case 65:
		case 47:
		case 45:
		case 41:
		case 60:
		case 84:
		case 66:
		case 56:
		case 52:
		case 71:
		case 25:
		case 73: return [27];
		case 51: return [52];
		case 89: return [
			21,
			82,
			50,
			57,
			83,
			67,
			51,
			47,
			45,
			40,
			46,
			60,
			84,
			66,
			20,
			30,
			56,
			34,
			71,
			73
		];
		case 27:
		case 12:
		case 100:
		case 200:
		case 150:
		case 120:
		case 110:
		case 11:
		case 10:
		case 130:
		case 68:
		case 2:
		case 34:
		case 28: return [];
	}
}
function addPrereqsToSet(right, prereqsSet) {
	function prereqsLoop(prereqs) {
		prereqs.forEach((prereq) => {
			if (!prereqsSet.has(prereq)) {
				prereqsSet.add(prereq);
				prereqsLoop(getDirectPrerequisites(prereq));
			}
		});
	}
	if (!prereqsSet.has(right)) prereqsLoop(getDirectPrerequisites(right));
}
/**
* @returns All rights that the user requires to have access to the given right.
*/
function getAllPrerequisites(right) {
	const prereqsSet = /* @__PURE__ */ new Set();
	addPrereqsToSet(right, prereqsSet);
	return Array.from(prereqsSet);
}
function rightsMeetPrerequisiteRequirements(rights) {
	return !findMissingPrerequisites(rights).length;
}
function findMissingPrerequisites(rights) {
	const prereqsSet = /* @__PURE__ */ new Set();
	rights.forEach((right) => {
		addPrereqsToSet(right, prereqsSet);
	});
	const rightsSet = new Set(rights);
	return Array.from(prereqsSet).filter((prereq) => {
		return !rightsSet.has(prereq);
	});
}
//#endregion
export { apiTokenRightName, findMissingPrerequisites, getAllPrerequisites, getDirectPrerequisites, isAdminRight, isApiRight, isApiTokenRight, isBiteRight, isResellerRight, rightsMeetPrerequisiteRequirements, user_right_helper_exports };

//# sourceMappingURL=user_right_helper.js.map